import BaseModel from '../base/BaseModel.model';
export default class Coin extends BaseModel {

   public coinId?: number;
   public currency?: string;
   

    init(){
       this.coinId = 0;
       this.currency = "";
    }

}